import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { GoogleButton } from "@/components/GoogleButton";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <AuthShell title="Start your garden" subtitle="Create an account to log your first sprout.">
      <GoogleButton label="Sign up with Google" />
      <form onSubmit={submit} className="space-y-4 mt-4" data-testid="register-form">
        <div className="space-y-1.5">
          <Label htmlFor="name">Name</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Jamie Green" required data-testid="register-name-input" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@garden.com" required data-testid="register-email-input" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" required data-testid="register-password-input" />
        </div>
        {error && (
          <p className="text-sm text-destructive" data-testid="register-error">
            {error}
          </p>
        )}
        <Button type="submit" disabled={loading} className="w-full bg-emerald-700 hover:bg-emerald-800 py-2.5" data-testid="register-submit-button">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
          Create account
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">
        Already growing?{" "}
        <Link to="/login" className="text-emerald-700 dark:text-emerald-400 font-semibold hover:underline" data-testid="go-login-link">
          Sign in
        </Link>
      </p>
    </AuthShell>
  );
}
